export const openWindow = (href, windowName = '_system', windowFeatures) => {
    const newWindow = window.open(href, windowName, windowFeatures);
    if (newWindow) {
        newWindow.opener = null;
    }
};
